






































import { Component, Vue, Watch } from 'vue-property-decorator'
import * as qs from 'qs'
import * as utils from '@ivy/fts/utils'
import { isWeixin } from '@ivy/fts/utils'
import { requireGet, requirePost } from './require'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component
export default class Index extends Vue {
  stepCont = [
    {
      num: 1,
      title: `微信搜索公众号并关注`,
      servicePublic: {
        name: '常青藤爸爸学堂',
        text: '点击【复制】复制公众号昵称：常青藤爸爸学堂',
        iconImg: require('./imgs/chinese-logo.png'),
      },
    },
    {
      num: 2,
      title: '点击【课程导航】 >> 【添加阅读指导官上课】',
      stepImg: require('./imgs/activation-step.png'),
    },
    {
      num: 3,
      title: '完成以上操作，添加阅读指导官后根据老师安排进行上课',
      tips: 'Tips：如何关注公众号👇',
      stepImg: require('./imgs/add-step.png'),
    },
  ]
  tid: string
  helperInfo: any
  courseInfo: any
  helperWechat: string
  course_start_time: string
  putPlat: string = ''

  async created() {
    const {
      order,
      result,
      total_fee,
      tid,
      course_start_time,
      bought,
    } = qs.parse(this.$route.query)
    if (!tid) return
    this.putPlat = utils.cacheGet('putPlat') || 'adSounds'
    this.tid = tid
    this.course_start_time = course_start_time
    await this.getData()
    if (utils.cacheGet('hasSendTid') === tid) return
    if (+bought === 1) return
    await this.sendPayDoneTempMsg()
  }
  async getData() {
    await env.init()
    if (env.type === 'web') return this.$Toast('请在微信中打开')
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
    const { data } = await requireGet(
      `/api/m-course/crm/crmUpdateRegister?tid=${this.tid}`
    )
    this.helperInfo = data.helper_info || {}
    this.courseInfo = data.course_info || {}
    this.helperWechat = this.helperInfo.wx_alias || this.helperInfo.wxid || ''
  }
  async onCopy(text) {
    this.$copyText(text).then(
      res => {
        this.$Toast('复制成功')
      },
      err => {
        this.$Toast('复制失败该浏览器不支持，请手动复制并打开微信添加')
      }
    )
    window.location.href = 'weixin://'
  }
  async sendPayDoneTempMsg() {
    const act_id = utils.cacheGet('actId')
    const channel_id = utils.cacheGet('channelId')
    const userInfo = await env.getInfo()
    let memId, openId, nickName
    if (env.type === 'ivydad') {
      memId = userInfo.userInfo.memId
      openId = userInfo.openId
      nickName = userInfo.userInfo.memberNick
    } else if (env.type === 'wx') {
      memId = userInfo.logined.user.id
      openId = userInfo.logined.openid
      nickName = userInfo.logined.user.member_nick
    }
    // 发送公众号模板消息
    await requireGet('/api/activity/crm/put/sendPayDoneTempMsg', {
      tid: this.tid,
      mem_id: memId,
      course_title: this.courseInfo.title,
      openid: openId,
      nickname: nickName,
      course_start_time: this.course_start_time,
    })
    utils.cacheSet('hasSendTid', this.tid)
    this.$Toast('报名成功')
  }
}
